import React, { useEffect, useState } from 'react'
import Card from '../component/Card'
import { useProductContext } from '../providers/ProductProvider'
import { CircleLoader } from 'react-spinners'

const Designe = () => {
  const {designs,loading}=useProductContext()
  useEffect(()=>{
    window.scrollTo({
        top:0,
        behavior:"smooth"
    })
},[])
  return (
    <div className='container'>
            {
              loading?(
                <div className=' container-fluid d-flex align-items-center justify-content-center '  style={{marginTop:"10%" ,marginBottom:"10%"}}> 
                <CircleLoader color="#ADD8E6" size={100} />
              </div>
              ):(
              <div className='row'>
              {
                designs?.map((e)=>(
                  <Card key={e._id} data={e}/>
                  ))
      }
    </div>
              )
            }

  </div>
  )
}

export default Designe
